/**
 * How a SoundCloud sign-in ended, as the return page hands it to Channels (`?soundCloud=`). The
 * sign-in lands on Channels, as every social connection does (owner, 2026-10-16). Only a sign-in
 * from the "Where it plays" panel goes back to its own page (`returnTo`).
 */
export const SOUNDCLOUD_CONNECT_RESULTS = ['connected', 'stateInvalid', 'refused', 'loginInUse', 'failed'] as const;
export type SoundCloudConnectResult = (typeof SOUNDCLOUD_CONNECT_RESULTS)[number];

export function toSoundCloudConnectResult(value: string | null): SoundCloudConnectResult | null {
  return SOUNDCLOUD_CONNECT_RESULTS.find((one) => one === value) ?? null;
}
